import { Alert, DetailList } from "../../../ui";
import type { Schemas } from "../../workspace/api.generated";

export function TransactionDocumentGuide({ guide }: {
  readonly guide?: Schemas["TransactionCategoryView"] | null;
}) {
  if (!guide) {
    return (
      <Alert persistent variant="warning" title="서류 안내 확인 필요">
        이 거래 유형의 서류 안내가 제공되지 않았습니다. 제출된 파일과 거래 정보를 직접 대조해 주세요.
      </Alert>
    );
  }

  return (
    <section aria-label={`${guide.name} 증빙 제출 안내`}>
      <DetailList items={[
        { label: "거래 유형", value: guide.name },
        { label: "안내 서류", value: guide.recommendedDocumentNames.join(", ") || "안내 서류가 없습니다." },
        {
          label: "제출 기준",
          value: guide.documentSubmissionPolicy === "ANY_EVIDENCE"
            ? `안내된 서류 중 하나 또는 대체 증빙 ${guide.minimumDocumentCount}개 이상 · 최대 ${guide.maximumDocumentCount}개`
            : "제출 기준을 확인할 수 없습니다. 최신 상태를 조회해 주세요.",
        },
      ]} />
      {guide.alternativeEvidenceDescription ? <p>{guide.alternativeEvidenceDescription}</p> : null}
    </section>
  );
}
